import {IFilterFunction} from "angular";
import {ExerciseStyle} from "../models/OrderResponse";

export const OptionStylePipeId = "tfOptionStyle";
export const OptionStyleShortPipeId = "tfOptionStyleShort";

export function optionStylePipe(): IFilterFunction {
    return (value: ExerciseStyle | null) => {
        if (value == null) {
            return null;
        }
        switch (value) {
            case ExerciseStyle.AMERICAN:
                return "American";
            case ExerciseStyle.EUROPEAN:
                return "European";
            default:
                return value;
        }
    };
}

export function optionStyleShortPipe(): IFilterFunction {
    return (value: ExerciseStyle | null) => {
        if (value == null) {
            return null;
        }
        switch (value) {
            case ExerciseStyle.AMERICAN:
                return "A";
            case ExerciseStyle.EUROPEAN:
                return "E";
            default:
                return value;
        }
    };
}
